/* JAQUAN CHANGE: Bronco Forge product page (sections/bf-product.liquid).
   - Photo counter ("2 / 5") while swiping on phones.
   - Options: picks the matching variant, then updates price, part number,
     GTIN, Add to cart, the free shipping line, the URL (?variant=) and
     jumps to that variant's photo.
   - Quantity buttons.
   - Phone bar (name, price, Add to cart) shows once the main Add to cart
     button is off screen.
   - Photo zoom: hover magnifier on desktop, full-screen viewer on click/tap
     (scroll-wheel and pinch zoom, drag, double-click, arrows, swipe). The viewer's
     buttons say what they do: "Zoom out" / "Zoom in", "Previous" / "Next photo" (v248).
   Add to cart itself is the theme's <product-form> (assets/product-form.js).
   No animations. */
(function () {
  'use strict';

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // JAQUAN CHANGE: gallery videos (YouTube/Vimeo) start as a cover photo with a play button; the real
  // player loads only when pressed, so the page doesn't download it for people who never watch.
  function initVideos() {
    if (initVideos.done) return;
    initVideos.done = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-bfp-yt]');
      if (!btn) return;
      var frame = document.createElement('iframe');
      frame.src = btn.getAttribute('data-bfp-yt');
      frame.title = btn.getAttribute('data-title') || 'Product video';
      frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      frame.allowFullscreen = true;
      btn.parentNode.replaceChild(frame, btn);
    });
  }

  function init(root) {
    if (root.dataset.bfpReady) return;
    root.dataset.bfpReady = '1';

    var track = root.querySelector('[data-bfp-track]');
    var count = root.querySelector('[data-bfp-count]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];

    function currentSlide() {
      if (!track) return 0;
      var w = track.clientWidth || 1;
      return Math.min(slides.length - 1, Math.max(0, Math.round(track.scrollLeft / w)));
    }

    if (track && count) {
      var total = count.getAttribute('data-total');
      var queued = false;
      track.addEventListener(
        'scroll',
        function () {
          if (queued) return;
          queued = true;
          requestAnimationFrame(function () {
            queued = false;
            count.textContent = currentSlide() + 1 + ' / ' + total;
          });
        },
        { passive: true }
      );
      track.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        if (getComputedStyle(track).display === 'grid') return;
        e.preventDefault();
        var i = currentSlide() + (e.key === 'ArrowRight' ? 1 : -1);
        i = Math.min(slides.length - 1, Math.max(0, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: 'auto' });
      });
    }

    function showMedia(mediaId) {
      if (!track || !mediaId) return;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(mediaId)) {
          if (getComputedStyle(track).display === 'grid') {
            if (i > 0) slides[i].scrollIntoView({ block: 'nearest', behavior: 'auto' });
          } else {
            track.scrollTo({ left: i * track.clientWidth, behavior: 'auto' });
          }
          return;
        }
      }
    }

    // ---------------- photo zoom ----------------
    initZoom(root, slides);

    // ---------------- delivery estimate ----------------
    // "Order today, get it Oct 14–17" from today's date in California time: the product's handling
    // days (data-min / data-max, from its shipping message) plus business days in transit.
    // Transit: 3–5 days, or for brands that ship from Arizona (data-origin="AZ") by the shopper's
    // region, guessed from the browser's time zone (no location lookup): Arizona 1–2, Pacific 1–3,
    // Mountain 2–3, Central 3–4, Eastern 4–5.
    // Same-day parts: ordered before 2 PM PT on a weekday ships today. Weekends are skipped.
    function shopperRegion() {
      var tz = '';
      try {
        tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      } catch (e) {}
      if (/^(America\/Phoenix|US\/Arizona)$/.test(tz)) return 'az';
      if (/^(America\/(Los_Angeles|Vancouver|Tijuana)|US\/Pacific)$/.test(tz)) return 'pacific';
      if (/^(America\/(Denver|Boise|Edmonton|Ojinaga)|US\/Mountain)$/.test(tz)) return 'mountain';
      if (/^(America\/(Chicago|Menominee|Winnipeg|Matamoros|Indiana\/(Knox|Tell_City)|North_Dakota\/\w+)|US\/Central)$/.test(tz)) return 'central';
      if (/^(America\/(New_York|Detroit|Toronto|Montreal|Indiana\/\w+|Kentucky\/\w+)|US\/(Eastern|Michigan))$/.test(tz)) return 'eastern';
      return '';
    }
    var TRANSIT_AZ = { az: [1, 2], pacific: [1, 3], mountain: [2, 3], central: [3, 4], eastern: [4, 5] };
    var etaEls = Array.prototype.slice.call(root.querySelectorAll('[data-bfp-eta]'));
    var etaDates = '';
    var etaShort = '';
    var etaSub = '';
    var etaFreeMin = etaEls.length ? parseInt(etaEls[0].getAttribute('data-free-min'), 10) : NaN;
    if (etaEls.length) {
      try {
        var parts = {};
        new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/Los_Angeles', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23'
        }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
        var today = new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day, 12));
        var hour = +parts.hour;
        var isBiz = function (d) { var w = d.getUTCDay(); return w !== 0 && w !== 6; };
        var addBiz = function (d, n) {
          var x = new Date(d.getTime());
          while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); if (isBiz(x)) n--; }
          return x;
        };
        var el0 = etaEls[0];
        var hMin = parseInt(el0.getAttribute('data-min'), 10) || 0;
        var hMax = parseInt(el0.getAttribute('data-max'), 10) || hMin;
        var sameDay = el0.getAttribute('data-same-day') === 'true';
        var beforeCutoff = isBiz(today) && hour < 14;
        var shipFirst = sameDay && beforeCutoff ? today : addBiz(today, Math.max(1, hMin));
        var shipLast = addBiz(today, Math.max(1, hMax));
        if (shipLast < shipFirst) shipLast = shipFirst;
        var transit = [3, 5];
        if (el0.getAttribute('data-origin') === 'AZ') transit = TRANSIT_AZ[shopperRegion()] || transit;
        var first = addBiz(shipFirst, transit[0]);
        var last = addBiz(shipLast, transit[1]);
        // "Tue, Oct 13 – Fri, Oct 16"
        var day = function (d) {
          return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' });
        };
        etaDates = first.getTime() === last.getTime() ? day(first) : day(first) + ' \u2013 ' + day(last);
        // Short form for the trust row: "Oct 9–14", or "Oct 30 – Nov 3" across months.
        var mon = function (d) { return d.toLocaleDateString('en-US', { month: 'short', timeZone: 'UTC' }); };
        etaShort = first.getTime() === last.getTime()
          ? mon(first) + ' ' + first.getUTCDate()
          : first.getUTCMonth() === last.getUTCMonth()
            ? mon(first) + ' ' + first.getUTCDate() + '\u2013' + last.getUTCDate()
            : mon(first) + ' ' + first.getUTCDate() + '\u2013' + mon(last) + ' ' + last.getUTCDate();
        if (sameDay && beforeCutoff) etaSub = 'Order by 2 PM PT to ship today';
        else if (sameDay || hMax <= 1) etaSub = 'Ships the next business day';
        else etaSub = 'Ships in ' + Math.max(1, hMin) + '\u2013' + hMax + ' business days';
      } catch (e) {
        etaDates = '';
      }
    }
    // Free when this option's price reaches the free shipping amount (0 = always free).
    function showEta(available, priceCents) {
      var free = !isNaN(etaFreeMin) && (etaFreeMin <= 0 || priceCents >= etaFreeMin);
      etaEls.forEach(function (el) {
        // Trust row: "Arrives Oct 9–14" in place of the shipping message (back to it when sold out).
        if (el.hasAttribute('data-inline')) {
          el.textContent = available && etaShort
            ? (el.getAttribute('data-prefix') || 'Arrives') + ' ' + etaShort
            : el.getAttribute('data-fallback') || '';
          return;
        }
        var main = el.querySelector('[data-bfp-eta-text]');
        var sub = el.querySelector('[data-bfp-eta-sub]');
        if (main && etaDates) main.textContent = (free ? 'Free delivery ' : 'Arrives ') + etaDates;
        if (sub) sub.textContent = etaSub;
        el.hidden = !etaDates || !available;
      });
    }

    // ---------------- military discount: crop the GovX widget to its link ----------------
    // The GovX app draws its widget itself (possibly where the page's styles can't reach), with
    // its own text and padding. Find its button or link, then crop the widget to just that.
    // All buttons and links inside the widget, also inside any shadow roots it uses.
    function govxCandidates(node, out) {
      if (!node || !node.querySelectorAll) return out;
      node.querySelectorAll('button, a, [role="button"]').forEach(function (el) {
        out.push(el);
      });
      node.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot) govxCandidates(el.shadowRoot, out);
      });
      return out;
    }
    // The tight box around the link's text (and icon), ignoring the app's padding.
    function govxBox(host) {
      var list = govxCandidates(host, []);
      if (host.shadowRoot) govxCandidates(host.shadowRoot, list);
      var best = null;
      list.forEach(function (el) {
        var range = document.createRange();
        range.selectNodeContents(el);
        var r = range.getBoundingClientRect();
        if (!r.width || !r.height) r = el.getBoundingClientRect();
        if (!r.width || !r.height) return;
        var score = (/verif/i.test(el.textContent) ? 0 : 1e9) + r.width * r.height;
        if (!best || score < best.score) best = { r: r, score: score };
      });
      return best && best.r;
    }
    function trimGovx() {
      root.querySelectorAll('[data-bfp-govx-clip]').forEach(function (clip) {
        var host = clip.querySelector('[data-govx-id]');
        if (!host) return;
        host.style.marginTop = '';
        host.style.marginLeft = '';
        clip.style.height = '';
        var r = govxBox(host);
        if (!r) return;
        var c = clip.getBoundingClientRect();
        host.style.marginTop = Math.round(c.top - r.top) + 'px';
        host.style.marginLeft = Math.round(c.left - r.left) + 'px';
        clip.style.height = Math.ceil(r.height + 2) + 'px';
        clip.style.width = Math.ceil(r.width + 2) + 'px';
        clip.classList.add('is-trimmed');
      });
    }
    (function () {
      var clips = root.querySelectorAll('[data-bfp-govx-clip]');
      if (!clips.length) return;
      var queued = false;
      var later = function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          trimGovx();
        });
      };
      clips.forEach(function (clip) {
        var host = clip.querySelector('[data-govx-id]');
        if (!host) return;
        // JAQUAN CHANGE: ignore our own style changes on the widget (trimGovx sets its margins), or every
        // trim would trigger the next one and the page would re-measure on every frame, nonstop.
        if (window.MutationObserver) {
          new MutationObserver(function (records) {
            for (var k = 0; k < records.length; k++) {
              var rec = records[k];
              if (rec.type === 'attributes' && rec.target === host && rec.attributeName === 'style') continue;
              later();
              return;
            }
          }).observe(host, { childList: true, subtree: true, attributes: true });
        }
      });
      window.addEventListener('resize', later);
      // JAQUAN CHANGE: the military discount sits in a dropdown; crop the link once it opens.
      root.querySelectorAll('.bfp__acc--govx').forEach(function (d) {
        d.addEventListener('toggle', later);
      });
      [0, 400, 1200, 2500, 5000].forEach(function (ms) {
        setTimeout(later, ms);
      });
      // GovX never showed anything (app off or blocked): hide the row instead of a dead line.
      setTimeout(function () {
        clips.forEach(function (clip) {
          var host = clip.querySelector('[data-govx-id]');
          var row = clip.closest('.bfp__acc--govx') || clip.closest('.bfp__govx');
          if (host && row && !host.shadowRoot && !host.firstElementChild && !host.textContent.trim()) row.hidden = true;
        });
      }, 8000);
    })();

    // ---------------- questions: "See all" ----------------
    root.querySelectorAll('[data-bfp-faq-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var box = document.getElementById(btn.getAttribute('aria-controls'));
        if (box) box.classList.remove('is-clipped');
        btn.hidden = true;
      });
    });

    // ---------------- variants ----------------
    var variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-bfp-variants]').textContent);
    } catch (e) {}

    var selects = Array.prototype.slice.call(root.querySelectorAll('[data-bfp-option]'));
    var idInput = root.querySelector('[data-bfp-id]');
    var priceEl = root.querySelector('[data-bfp-price]');
    var wasEl = root.querySelector('[data-bfp-was]');
    var barPrice = root.querySelector('[data-bfp-bar-price]');
    var atc = root.querySelector('[data-bfp-atc]');
    // Button text from the Add to cart block's settings.
    var addLabel = (atc && atc.getAttribute('data-label-add')) || 'Add to cart';
    var soldLabel = (atc && atc.getAttribute('data-label-sold')) || 'Sold out';
    var atcText = root.querySelector('[data-bfp-atc-text]');
    var barAtc = root.querySelector('[data-bfp-bar-atc]');
    var free = root.querySelector('[data-bfp-free]');
    (function () {
      var cv = currentVariant();
      showEta(!(atc && atc.disabled), cv ? cv.priceCents : 0);
    })();

    function setText(selector, text) {
      root.querySelectorAll(selector).forEach(function (el) {
        el.textContent = text;
      });
    }

    function update(v) {
      var available = !!(v && v.available);
      var label = !v ? 'Unavailable' : available ? addLabel : soldLabel;
      if (v) {
        if (idInput) idInput.value = v.id;
        // Price shows in the price block and, on wide desktop, in the buy box too.
        setText('[data-bfp-price]', v.price);
        if (barPrice) barPrice.textContent = v.price;
        root.querySelectorAll('[data-bfp-was]').forEach(function (el) {
          el.textContent = v.compare || '';
          el.hidden = !v.compare;
        });
        if (v.sku) setText('[data-bfp-sku]', v.sku);
        if (v.barcode) setText('[data-bfp-gtin]', v.barcode);
        if (free && free.getAttribute('data-freight') !== 'true') {
          var min = parseInt(free.getAttribute('data-min'), 10) || 0;
          var freeLabel = free.querySelector('b');
          if (freeLabel) {
            // Titles come from the Trust badges block settings ([min] = the free shipping amount).
            freeLabel.textContent = v.priceCents >= min
              ? free.getAttribute('data-title') || 'Free shipping'
              : (free.getAttribute('data-title-under') || 'Free shipping [min]+').replace('[min]', money(min).replace('.00', ''));
          }
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', url.toString());
        showMedia(v.media);
      }
      if (idInput) idInput.disabled = !available;
      showEta(available, v ? v.priceCents : 0);
      if (atc) atc.disabled = !available;
      if (atcText) atcText.textContent = label;
      if (barAtc) {
        barAtc.disabled = !available;
        barAtc.textContent = label;
      }
      refreshAddons();
    }

    if (selects.length && variants.length) {
      selects.forEach(function (select) {
        select.addEventListener('change', function () {
          var chosen = selects.map(function (s) {
            return s.value;
          });
          var match = null;
          for (var i = 0; i < variants.length; i++) {
            var same = variants[i].options.every(function (o, j) {
              return o === chosen[j];
            });
            if (same) {
              match = variants[i];
              break;
            }
          }
          update(match);
        });
      });
    }

    // ---------------- quantity ----------------
    var qty = root.querySelector('.bfp__qty-input');
    if (qty) root.querySelectorAll('[data-bfp-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var n = (parseInt(qty.value, 10) || 1) + parseInt(btn.getAttribute('data-bfp-qty'), 10);
        qty.value = Math.max(1, n);
      });
    });

    // ---------------- sold in sets (wheels) ----------------
    // "Set of 4: $1,995.92" under the price, kept in step with the option and quantity.
    // (The set line shows under the price and, on wide desktop, in the buy box too.)
    var setLines = Array.prototype.slice.call(root.querySelectorAll('[data-bfp-set]'));
    if (setLines.length && qty) {
      var setSize = parseInt(setLines[0].getAttribute('data-qty'), 10) || 1;
      var refreshSet = function () {
        var q = Math.max(1, parseInt(qty.value, 10) || 1);
        var v = null;
        for (var i = 0; i < variants.length; i++) {
          if (idInput && String(variants[i].id) === String(idInput.value)) v = variants[i];
        }
        if (!v) v = variants[0];
        setLines.forEach(function (setLine) {
          var setTotal = setLine.querySelector('[data-bfp-set-total]');
          setLine.hidden = q < 2 || !v;
          if (!v) return;
          setLine.firstChild.textContent = q === setSize ? 'Set of ' + q + ': ' : 'Total for ' + q + ': ';
          setTotal.textContent = money(v.priceCents * q);
        });
      };
      qty.addEventListener('input', refreshSet);
      root.querySelectorAll('[data-bfp-qty], [data-bfp-option]').forEach(function (el) {
        el.addEventListener(el.matches('select') ? 'change' : 'click', function () {
          setTimeout(refreshSet, 0);
        });
      });
    }

    // ---------------- real Bronco photos ----------------
    // Tap a photo in the strip: same full-screen viewer as the product photos.
    root.querySelectorAll('[data-bfp-owners]').forEach(function (box) {
      var items = Array.prototype.slice.call(box.querySelectorAll('[data-zoom]'));
      var list = items.map(function (el) {
        return {
          src: el.getAttribute('data-zoom'),
          w: parseInt(el.getAttribute('data-zoom-w'), 10) || 0,
          h: parseInt(el.getAttribute('data-zoom-h'), 10) || 0,
          alt: el.getAttribute('data-alt') || '',
          thumb: el.querySelector('img')
        };
      });
      items.forEach(function (el, i) {
        el.addEventListener('click', function () {
          openViewer(list, i);
        });
      });
    });

    // ---------------- cart: add several items at once ----------------
    // POST /cart/add.js with every item, then refresh the cart drawer and open it.
    // done(errorText) is called with null when the items went in.
    function addItems(items, opener, done) {
      var minicart = document.querySelector('mini-cart');
      var payload = { items: items };
      if (minicart && typeof minicart.getSectionsToRender === 'function' && typeof getUniqueSectionNames === 'function') {
        try {
          payload.sections = getUniqueSectionNames(minicart.getSectionsToRender());
          payload.sections_url = location.pathname;
        } catch (e) {}
      }
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          return res.json().then(
            function (data) {
              return { ok: res.ok, data: data };
            },
            function () {
              return { ok: false, data: {} };
            }
          );
        })
        .then(function (r) {
          var response = r.data || {};
          // Not added (sold out, not enough stock...): say why.
          if (!r.ok || response.status) {
            done(response.description || response.message || 'That didn’t go through. Please try again.');
            return;
          }
          // Added. From here on nothing is an error for the shopper:
          // refresh the cart drawer as best we can and open it.
          done(null);
          var opened = false;
          var openCart = function () {
            if (opened) return;
            opened = true;
            try {
              minicart.open(opener);
            } catch (e) {
              location.href = '/cart';
            }
          };
          if (!minicart || typeof minicart.open !== 'function') {
            location.href = '/cart';
            return;
          }
          var drawn = false;
          if (response.sections && typeof minicart.renderContents === 'function') {
            try {
              minicart.renderContents(response);
              drawn = true;
            } catch (e) {
              if (window.console) console.warn('[bf-bundle] cart refresh', e);
            }
          }
          if (!drawn && typeof minicart.updateSectionContents === 'function') {
            Promise.resolve()
              .then(function () {
                return minicart.updateSectionContents();
              })
              .catch(function () {})
              .then(openCart);
          } else {
            openCart();
          }
          try {
            if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              window.publish(PUB_SUB_EVENTS.cartItemAdd, { source: 'bf-bundle', items: response.items || [] });
            }
          } catch (e) {}
        })
        .catch(function (e) {
          if (window.console) console.warn('[bf-bundle]', e);
          done('That didn’t go through. Please try again.');
        });
    }

    function currentVariant() {
      for (var i = 0; i < variants.length; i++) {
        if (idInput && String(variants[i].id) === String(idInput.value)) return variants[i];
      }
      return null;
    }

    function pickedItems(boxes) {
      var items = [];
      var total = 0;
      boxes.forEach(function (box) {
        if (!box.checked) return;
        var pq = parseInt(box.getAttribute('data-qty'), 10) || 1;
        items.push({ id: parseInt(box.getAttribute('data-variant'), 10), quantity: pq });
        total += (parseInt(box.getAttribute('data-price'), 10) || 0) * pq;
      });
      return { items: items, total: total };
    }

    // ---------------- add-ons with the main Add to cart ----------------
    // "Completes the setup" in main-button mode: the boxes start unticked. Each ticked part
    // turns Add to cart (and the phone bar) into "Add 2 items to cart" with the total, and
    // the button adds this part plus the ticked parts in one go. Nothing ticked: the normal
    // Add to cart. Shop Pay / Buy it now still buys just this part.
    // Desktop/phones mode (data-bf-bundle-split): this only applies while the box sits in the
    // wide-desktop card column; everywhere else it's the own-button mode below.
    var mainBox = root.querySelector('[data-bf-bundle-main], [data-bf-bundle-split]');
    var addonPicks = mainBox ? Array.prototype.slice.call(mainBox.querySelectorAll('[data-bf-pick]')) : [];
    var atcTotal = root.querySelector('[data-bfp-atc-total]');
    var formError = root.querySelector('.bfp__error');
    var addonBusy = false;

    function addonsOn() {
      if (!mainBox) return false;
      if (!mainBox.hasAttribute('data-bf-bundle-split')) return true;
      return !!mainBox.closest('[data-bfp-card]');
    }

    function addonState() {
      var v = currentVariant();
      var q = qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1;
      var picked = pickedItems(addonPicks);
      var available = !!(v && v.available) && !(idInput && idInput.disabled);
      return {
        v: v,
        q: q,
        picked: picked,
        on: available && picked.items.length > 0 && addonsOn(),
        available: available,
        total: (v ? v.priceCents * q : 0) + picked.total
      };
    }

    function refreshAddons() {
      if (!mainBox || !addonPicks.length || addonBusy) return;
      var st = addonState();
      var n = st.picked.items.length + 1;
      if (st.available && atcText) atcText.textContent = st.on ? 'Add ' + n + ' items to cart' : addLabel;
      // The total shows as the price (with "This part $X + add-ons" under it), not on the button.
      if (atcTotal) {
        atcTotal.hidden = true;
        atcTotal.textContent = '';
      }
      if (st.v) {
        root.querySelectorAll('[data-bfp-price]').forEach(function (el) {
          el.textContent = st.on ? money(st.total) : st.v.price;
        });
        root.querySelectorAll('[data-bfp-was]').forEach(function (el) {
          el.hidden = st.on || !st.v.compare;
        });
        root.querySelectorAll('[data-bfp-price-note]').forEach(function (el) {
          el.hidden = !st.on;
          var part = el.querySelector('[data-bfp-price-part]');
          if (part) part.textContent = st.on ? money(st.v.priceCents * st.q) : '';
        });
      }
      if (atc) atc.classList.toggle('is-bundle', st.on);
      if (barAtc && st.available) barAtc.textContent = st.on ? 'Add ' + n + ' items' : addLabel;
      if (barPrice && st.v) barPrice.textContent = st.on ? money(st.total) : st.v.price;
    }

    if (mainBox && addonPicks.length && idInput && idInput.form) {
      addonPicks.forEach(function (box) {
        if (!mainBox.hasAttribute('data-bf-bundle-split')) box.checked = false;
        box.addEventListener('change', refreshAddons);
      });
      if (qty) qty.addEventListener('input', refreshAddons);
      root.querySelectorAll('[data-bfp-qty]').forEach(function (el) {
        el.addEventListener('click', function () {
          setTimeout(refreshAddons, 0);
        });
      });

      // Catch the form's submit before the theme's product form does (capture on its
      // parent), but only when parts are ticked. The phone bar's button submits the same form.
      var cartForm = idInput.form;
      var formHost = cartForm.closest('product-form') || cartForm.parentNode;
      formHost.addEventListener(
        'submit',
        function (e) {
          var st = addonState();
          if (!st.on || !st.v) return;
          e.preventDefault();
          e.stopPropagation();
          if (addonBusy) return;
          addonBusy = true;
          var spinner = atc ? atc.querySelector('.button-overlay-spinner') : null;
          if (atc) {
            atc.classList.add('loading');
            atc.setAttribute('aria-disabled', 'true');
          }
          if (spinner) spinner.classList.remove('hidden');
          if (barAtc) barAtc.disabled = true;
          if (formError) formError.hidden = true;
          var opener = e.submitter || atc;
          addItems([{ id: st.v.id, quantity: st.q }].concat(st.picked.items), opener, function (err) {
            addonBusy = false;
            if (atc) {
              atc.classList.remove('loading');
              atc.removeAttribute('aria-disabled');
            }
            if (spinner) spinner.classList.add('hidden');
            if (barAtc) barAtc.disabled = !(st.v && st.v.available);
            if (err) {
              if (formError) {
                var msg = formError.querySelector('.product-form-error-message');
                if (msg) msg.textContent = err;
                formError.hidden = false;
              }
            } else {
              addonPicks.forEach(function (box) {
                box.checked = false;
              });
            }
            refreshAddons();
          });
        },
        true
      );
      refreshAddons();
    }

    // ---------------- add all to cart (own button) ----------------
    // "Completes the setup" set to its own button: the boxes start ticked and one button
    // adds this part (the chosen option and quantity) plus every ticked part.
    var bundle = root.querySelector('[data-bf-bundle]');
    if (bundle && idInput) {
      var picks = Array.prototype.slice.call(bundle.closest('[data-bf-bundle-box]').querySelectorAll('[data-bf-pick]'));
      var bundleBtn = bundle.querySelector('[data-bf-bundle-add]');
      var bundleMsg = bundle.querySelector('[data-bf-bundle-msg]');
      var busy = false;

      var bundleItems = function () {
        var items = [];
        var total = 0;
        if (!idInput.disabled) {
          var main = currentVariant();
          var q = qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1;
          if (main) {
            items.push({ id: main.id, quantity: q });
            total += main.priceCents * q;
          }
        }
        var picked = pickedItems(picks);
        return { items: items.concat(picked.items), total: total + picked.total };
      };

      var refreshBundle = function () {
        if (busy) return;
        var b = bundleItems();
        var n = b.items.reduce(function (sum, it) {
          return sum + it.quantity;
        }, 0);
        bundleBtn.disabled = b.items.length === 0;
        bundleBtn.textContent =
          b.items.length < 2
            ? 'Add to cart · ' + money(b.total)
            : 'Add all ' + n + ' to cart · ' + money(b.total);
        if (!b.items.length) bundleBtn.textContent = 'Pick a part to add';
      };

      picks.forEach(function (box) {
        box.addEventListener('change', refreshBundle);
      });
      if (qty) qty.addEventListener('input', refreshBundle);
      root.querySelectorAll('[data-bfp-qty], [data-bfp-option]').forEach(function (el) {
        el.addEventListener(el.matches('select') ? 'change' : 'click', function () {
          setTimeout(refreshBundle, 0);
        });
      });

      bundleBtn.addEventListener('click', function () {
        var b = bundleItems();
        if (!b.items.length || busy) return;
        busy = true;
        bundleBtn.disabled = true;
        bundleBtn.textContent = 'Adding…';
        bundleMsg.hidden = true;
        addItems(b.items, bundleBtn, function (err) {
          busy = false;
          if (err) {
            bundleMsg.textContent = err;
            bundleMsg.hidden = false;
          }
          refreshBundle();
        });
      });

      bundle.hidden = false;
      refreshBundle();

      // Desktop/phones mode: switch when the box moves in or out of the card column
      // (the section's inline script moves it at 1360px). Main button: unticked, own
      // button hidden. Own button: ticked.
      if (mainBox && mainBox.hasAttribute('data-bf-bundle-split')) {
        var splitOn = null;
        var applySplit = function () {
          var on = addonsOn();
          if (on === splitOn) return;
          splitOn = on;
          picks.forEach(function (box) {
            var extra = box.closest('[data-bf-pairs-extra]');
            box.checked = !on && !(extra && extra.hidden);
          });
          mainBox.toggleAttribute('data-bf-bundle-main', on);
          bundle.hidden = on;
          refreshAddons();
          refreshBundle();
        };
        applySplit();
        var splitMq = window.matchMedia('(min-width: 1360px)');
        var splitLater = function () {
          setTimeout(applySplit, 0);
        };
        if (splitMq.addEventListener) splitMq.addEventListener('change', splitLater);
        else if (splitMq.addListener) splitMq.addListener(splitLater);
      }
    }

    // ---------------- phone bar ----------------
    var bar = root.querySelector('[data-bfp-bar]');
    var cart = root.querySelector('[data-bfp-cart]');
    if (bar && cart) {
      var barQueued = false;
      var checkBar = function () {
        barQueued = false;
        // Show once the main button has scrolled up out of view (not before reaching it).
        bar.hidden = cart.getBoundingClientRect().bottom > 0;
      };
      var queueBar = function () {
        if (barQueued) return;
        barQueued = true;
        requestAnimationFrame(checkBar);
      };
      window.addEventListener('scroll', queueBar, { passive: true });
      window.addEventListener('resize', queueBar);
      checkBar();
    }
  }

  /* ---------------- photo zoom ----------------
     Desktop (mouse): hovering a photo magnifies it under the cursor using
     the large (2400px) image.
     Click / tap: full-screen viewer. Scroll wheel zooms in and out around
     the cursor, drag moves the photo, double-click (double-tap) zooms in or
     back out, two-finger pinch on phones, swipe or arrows for the next photo,
     Esc or the X closes. No animations. */
  var viewer = null;

  function initZoom(root, slides) {
    var zoomSlides = slides.filter(function (el) {
      return el.hasAttribute('data-zoom');
    });
    if (!zoomSlides.length) return;
    var photos = zoomSlides.map(function (el) {
      return {
        src: el.getAttribute('data-zoom'),
        thumb: el.querySelector('img'),
        w: parseInt(el.getAttribute('data-zoom-w'), 10) || 0,
        h: parseInt(el.getAttribute('data-zoom-h'), 10) || 0,
        alt: el.getAttribute('data-alt') || ''
      };
    });
    var fineMouse = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    zoomSlides.forEach(function (slide, i) {
      slide.setAttribute('role', 'button');
      slide.setAttribute('tabindex', '0');
      slide.setAttribute('aria-label', 'Zoom photo ' + (i + 1) + ' of ' + zoomSlides.length);
      slide.addEventListener('click', function () {
        openViewer(photos, i);
      });
      slide.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openViewer(photos, i);
        }
      });

      if (!fineMouse) return;
      // Side zoom (desktop): an orange box follows the mouse over the photo and
      // a large pane next to the photos (over the buy column) shows that spot
      // up close. The photo already on the page sits under the large one, so
      // the pane shows right away and sharpens when the large photo arrives.
      var lens = null;
      var ZOOM = 2.5;
      function imageBox() {
        // Where the photo is drawn inside its frame (object-fit: contain).
        var r = slide.getBoundingClientRect();
        var p = photos[i];
        var k = Math.min(r.width / (p.w || r.width), r.height / (p.h || r.height));
        var w = (p.w || r.width) * k;
        var h = (p.h || r.height) * k;
        return { r: r, x: (r.width - w) / 2, y: (r.height - h) / 2, w: w, h: h };
      }
      function place(e) {
        var box = imageBox();
        var pane = zoomPane();
        // Pane: over the buy column, from the top of the photo, inside the window.
        var buy = root.querySelector('.bfp__buy');
        var br = buy ? buy.getBoundingClientRect() : { left: box.r.right + 24, width: 560 };
        var pw = Math.min(br.width, 720);
        var top = Math.max(12, box.r.top);
        var ph = Math.min(pw, window.innerHeight - top - 12);
        pane.style.left = br.left + 'px';
        pane.style.top = top + 'px';
        pane.style.width = pw + 'px';
        pane.style.height = ph + 'px';
        // Box on the photo: the part of the photo the pane is showing.
        var lw = Math.min(box.w, pw / ZOOM);
        var lh = Math.min(box.h, ph / ZOOM);
        var mx = e.clientX - box.r.left;
        var my = e.clientY - box.r.top;
        var lx = Math.min(box.x + box.w - lw, Math.max(box.x, mx - lw / 2));
        var ly = Math.min(box.y + box.h - lh, Math.max(box.y, my - lh / 2));
        lens.style.left = lx + 'px';
        lens.style.top = ly + 'px';
        lens.style.width = lw + 'px';
        lens.style.height = lh + 'px';
        var low = lowSrc(photos[i]);
        var img = 'url("' + photos[i].src + '")' + (low ? ', url("' + low + '")' : '');
        if (pane.dataset.img !== img) {
          pane.style.backgroundImage = img;
          pane.dataset.img = img;
        }
        var sx = pw / lw;
        var sy = ph / lh;
        pane.style.backgroundSize = box.w * sx + 'px ' + box.h * sy + 'px';
        pane.style.backgroundPosition = -(lx - box.x) * sx + 'px ' + -(ly - box.y) * sy + 'px';
        pane.hidden = false;
        lens.hidden = false;
      }
      slide.addEventListener('mouseenter', function (e) {
        if (getComputedStyle(slide.parentNode).display !== 'grid') return; // desktop layout only
        // JAQUAN CHANGE: load only this photo's large version (not every photo's at once).
        preload(photos[i].src);
        if (!lens) {
          lens = document.createElement('div');
          lens.className = 'bfp__lens';
          lens.setAttribute('aria-hidden', 'true');
          slide.appendChild(lens);
        }
        place(e);
      });
      // JAQUAN CHANGE: move the zoom box at most once per frame, not on every mouse event.
      var moveEvt = null;
      slide.addEventListener('mousemove', function (e) {
        if (!lens || lens.hidden) return;
        var pending = moveEvt;
        moveEvt = e;
        if (pending) return;
        requestAnimationFrame(function () {
          var ev = moveEvt;
          moveEvt = null;
          if (ev && lens && !lens.hidden) place(ev);
        });
      });
      slide.addEventListener('mouseleave', function () {
        if (lens) lens.hidden = true;
        if (pane) pane.hidden = true;
      });
      slide.addEventListener('click', function () {
        if (lens) lens.hidden = true;
        if (pane) pane.hidden = true;
      });
    });
  }

  // The one side-zoom pane, shared by every photo.
  var pane = null;
  function zoomPane() {
    if (!pane) {
      pane = document.createElement('div');
      pane.className = 'bfp-zoompane';
      pane.appendChild(document.createElement('span')); // not :empty, so the theme's empty-div rule leaves it alone
      pane.setAttribute('aria-hidden', 'true');
      pane.hidden = true;
      document.body.appendChild(pane);
      // Scrolling moves the photo away from the mouse: hide until it moves again.
      window.addEventListener(
        'scroll',
        function () {
          pane.hidden = true;
          document.querySelectorAll('.bfp__lens').forEach(function (l) {
            l.hidden = true;
          });
        },
        { passive: true }
      );
    }
    return pane;
  }

  // Large photos that finished loading, and ones on the way.
  var loaded = {};
  var loading = {};

  function preload(src, done) {
    if (!src) return;
    if (loaded[src]) {
      if (done) done();
      return;
    }
    var im = loading[src];
    if (!im) {
      im = loading[src] = new Image();
      im.decoding = 'async';
      im.addEventListener('load', function () {
        loaded[src] = true;
      });
      im.src = src;
    }
    if (done) im.addEventListener('load', done);
  }

  // The size of this photo that is already loaded on the page, if any.
  function lowSrc(p) {
    var t = p.thumb;
    return t && t.complete && t.naturalWidth ? t.currentSrc || t.src : '';
  }

  // Phosphor Regular icons (256 grid).
  function svgIcon(path) {
    return '<svg viewBox="0 0 256 256" width="24" height="24" fill="currentColor" aria-hidden="true">' + path + '</svg>';
  }

  function buildViewer() {
    var d = document.createElement('dialog');
    d.className = 'bfp-zoom';
    d.setAttribute('aria-label', 'Photo viewer');
    d.innerHTML =
      '<div class="bfp-zoom__stage" data-z-stage><img class="bfp-zoom__img" data-z-img alt="" draggable="false"></div>' +
      '<button type="button" class="bfp-zoom__btn bfp-zoom__close" data-z-close aria-label="Close">' + svgIcon('<path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"/>') + '</button>' +
      // JAQUAN CHANGE (v248): buttons that say what they do. Paging and zoom are apart, so nobody
      // reads Zoom out / Zoom in as back / next. "Photo 2 of 5" sits top left on its own. Phones:
      // wide "Previous" / "Next photo" buttons at the bottom, dots, and the zoom buttons at the top.
      '<p class="bfp-zoom__count" data-z-count aria-live="polite"></p>' +
      '<button type="button" class="bfp-zoom__btn bfp-zoom__prev" data-z-prev aria-label="Previous photo">' + svgIcon('<path d="M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"/>') + '<span class="bfp-zoom__lbl" aria-hidden="true">Previous</span></button>' +
      '<button type="button" class="bfp-zoom__btn bfp-zoom__next" data-z-next aria-label="Next photo"><span class="bfp-zoom__lbl" aria-hidden="true">Next photo</span>' + svgIcon('<path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"/>') + '</button>' +
      '<div class="bfp-zoom__dots" data-z-dots aria-hidden="true"></div>' +
      '<p class="bfp-zoom__hint" data-z-hint></p>' +
      '<div class="bfp-zoom__bar" role="group" aria-label="Zoom">' +
      '<button type="button" class="bfp-zoom__zb" data-z-out>' + svgIcon('<path d="M152,112a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h64A8,8,0,0,1,152,112Zm77.66,117.66a8,8,0,0,1-11.32,0l-50.06-50.07a88.11,88.11,0,1,1,11.31-11.31l50.07,50.06A8,8,0,0,1,229.66,229.66ZM112,184a72,72,0,1,0-72-72A72.08,72.08,0,0,0,112,184Z"/>') + '<span>Zoom out</span></button>' +
      '<button type="button" class="bfp-zoom__zb" data-z-in>' + svgIcon('<path d="M152,112a8,8,0,0,1-8,8H120v24a8,8,0,0,1-16,0V120H80a8,8,0,0,1,0-16h24V80a8,8,0,0,1,16,0v24h24A8,8,0,0,1,152,112Zm77.66,117.66a8,8,0,0,1-11.32,0l-50.06-50.07a88.11,88.11,0,1,1,11.31-11.31l50.07,50.06A8,8,0,0,1,229.66,229.66ZM112,184a72,72,0,1,0-72-72A72.08,72.08,0,0,0,112,184Z"/>') + '<span>Zoom in</span></button>' +
      '</div>';
    document.body.appendChild(d);

    var stage = d.querySelector('[data-z-stage]');
    var img = d.querySelector('[data-z-img]');
    var count = d.querySelector('[data-z-count]');
    var dots = d.querySelector('[data-z-dots]');
    var hint = d.querySelector('[data-z-hint]');
    var touch = window.matchMedia ? window.matchMedia('(pointer: coarse)') : null;
    var v = { el: d, photos: [], i: 0, s: 1, tx: 0, ty: 0, fit: { x: 0, y: 0, w: 0, h: 0 }, pointers: {}, pinch: null, drag: null, lastTap: 0, savedOverflow: '' };
    var MAX = 6;

    function stageSize() {
      return { w: stage.clientWidth, h: stage.clientHeight };
    }

    function computeFit() {
      var st = stageSize();
      var p = v.photos[v.i];
      // Use the photo's real size, not whichever copy (small or large) is showing.
      var iw = p.w || img.naturalWidth || 1;
      var ih = p.h || img.naturalHeight || 1;
      var k = Math.min(st.w / iw, st.h / ih);
      var w = iw * k;
      var h = ih * k;
      v.fit = { x: (st.w - w) / 2, y: (st.h - h) / 2, w: w, h: h };
      img.style.left = v.fit.x + 'px';
      img.style.top = v.fit.y + 'px';
      img.style.width = w + 'px';
      img.style.height = h + 'px';
    }

    function clamp() {
      var st = stageSize();
      var sw = v.fit.w * v.s;
      var sh = v.fit.h * v.s;
      if (sw <= st.w) v.tx = (st.w - sw) / 2 - v.fit.x;
      else v.tx = Math.min(-v.fit.x, Math.max(st.w - v.fit.x - sw, v.tx));
      if (sh <= st.h) v.ty = (st.h - sh) / 2 - v.fit.y;
      else v.ty = Math.min(-v.fit.y, Math.max(st.h - v.fit.y - sh, v.ty));
    }

    function apply() {
      clamp();
      img.style.transform = 'translate(' + v.tx + 'px,' + v.ty + 'px) scale(' + v.s + ')';
      d.classList.toggle('is-zoomed', v.s > 1.01);
    }

    function zoomAt(px, py, next) {
      next = Math.min(MAX, Math.max(1, next));
      var ux = (px - v.fit.x - v.tx) / v.s;
      var uy = (py - v.fit.y - v.ty) / v.s;
      v.s = next;
      v.tx = px - v.fit.x - next * ux;
      v.ty = py - v.fit.y - next * uy;
      apply();
    }

    function stagePoint(e) {
      var r = stage.getBoundingClientRect();
      return { x: e.clientX - r.left, y: e.clientY - r.top };
    }

    function reset() {
      v.s = 1;
      v.tx = 0;
      v.ty = 0;
      computeFit();
      apply();
    }

    // Switches photos right away: shows the copy already on the page, then
    // swaps in the large photo once it has loaded. Neighbors load ahead.
    function show(i) {
      var n = v.photos.length;
      v.i = (i + n) % n;
      var p = v.photos[v.i];
      var token = (v.token = (v.token || 0) + 1);
      img.alt = p.alt;
      if (loaded[p.src]) {
        img.src = p.src;
      } else {
        // Not loaded on the page yet (a later phone slide): the smaller page
        // copy still arrives well before the large one.
        var low = lowSrc(p) || (p.thumb && p.thumb.src) || '';
        if (low) img.src = low;
        else img.removeAttribute('src');
        preload(p.src, function () {
          if (v.token === token) img.src = p.src;
        });
      }
      reset();
      count.textContent = n > 1 ? 'Photo ' + (v.i + 1) + ' of ' + n : '';
      d.classList.toggle('is-single', n < 2);
      // Dots on phones (up to 12 photos).
      var marks = [];
      if (n > 1 && n <= 12) {
        for (var k = 0; k < n; k++) {
          var dot = document.createElement('i');
          if (k === v.i) dot.className = 'is-on';
          marks.push(dot);
        }
      }
      dots.replaceChildren.apply(dots, marks);
      var isTouch = touch && touch.matches;
      hint.textContent = isTouch
        ? 'Pinch to zoom' + (n > 1 ? ' \u00b7 Swipe for the next photo' : '')
        : 'Scroll or double-click to zoom \u00b7 Drag to move around';
      if (n > 1) {
        preload(v.photos[(v.i + 1) % n].src);
        preload(v.photos[(v.i - 1 + n) % n].src);
      }
    }

    v.open = function (photos, i) {
      v.photos = photos;
      if (!v.isOpen) {
        v.isOpen = true;
        v.savedOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
      }
      if (typeof d.showModal === 'function') d.showModal();
      else d.setAttribute('open', '');
      show(i);
    };

    function close() {
      if (d.open && typeof d.close === 'function') d.close();
      else d.removeAttribute('open');
      afterClose();
    }
    function afterClose() {
      if (!v.isOpen) return;
      v.isOpen = false;
      document.documentElement.style.overflow = v.savedOverflow;
    }
    d.addEventListener('close', afterClose);

    d.querySelector('[data-z-close]').addEventListener('click', close);
    d.querySelector('[data-z-prev]').addEventListener('click', function () { show(v.i - 1); });
    d.querySelector('[data-z-next]').addEventListener('click', function () { show(v.i + 1); });
    d.querySelector('[data-z-in]').addEventListener('click', function () {
      var st = stageSize();
      zoomAt(st.w / 2, st.h / 2, v.s * 1.5);
    });
    d.querySelector('[data-z-out]').addEventListener('click', function () {
      var st = stageSize();
      zoomAt(st.w / 2, st.h / 2, v.s / 1.5);
    });

    d.addEventListener('keydown', function (e) {
      var st = stageSize();
      if (e.key === 'ArrowRight') show(v.i + 1);
      else if (e.key === 'ArrowLeft') show(v.i - 1);
      else if (e.key === '+' || e.key === '=') zoomAt(st.w / 2, st.h / 2, v.s * 1.5);
      else if (e.key === '-') zoomAt(st.w / 2, st.h / 2, v.s / 1.5);
      else return;
      e.preventDefault();
    });

    stage.addEventListener(
      'wheel',
      function (e) {
        e.preventDefault();
        var p = stagePoint(e);
        var delta = e.deltaMode === 1 ? e.deltaY * 33 : e.deltaY;
        zoomAt(p.x, p.y, v.s * Math.exp(-delta * 0.0022));
      },
      { passive: false }
    );

    // Click outside the photo (on the dark area) closes, when not zoomed.
    stage.addEventListener('click', function (e) {
      if (v.s <= 1.01 && !v.moved && !onPhoto(stagePoint(e))) close();
    });

    stage.addEventListener('pointerdown', function (e) {
      stage.setPointerCapture(e.pointerId);
      v.pointers[e.pointerId] = stagePoint(e);
      v.moved = false;
      var ids = Object.keys(v.pointers);
      if (ids.length === 2) {
        var a = v.pointers[ids[0]];
        var b = v.pointers[ids[1]];
        v.pinch = { dist: Math.hypot(a.x - b.x, a.y - b.y), s: v.s };
        v.drag = null;
      } else if (ids.length === 1) {
        var p = v.pointers[ids[0]];
        v.drag = { x: p.x, y: p.y, tx: v.tx, ty: v.ty, startX: p.x };
      }
    });

    stage.addEventListener('pointermove', function (e) {
      if (!v.pointers[e.pointerId]) return;
      v.pointers[e.pointerId] = stagePoint(e);
      var ids = Object.keys(v.pointers);
      if (v.pinch && ids.length >= 2) {
        var a = v.pointers[ids[0]];
        var b = v.pointers[ids[1]];
        var dist = Math.hypot(a.x - b.x, a.y - b.y);
        v.moved = true;
        zoomAt((a.x + b.x) / 2, (a.y + b.y) / 2, v.pinch.s * (dist / (v.pinch.dist || 1)));
      } else if (v.drag) {
        var p = v.pointers[e.pointerId];
        if (Math.abs(p.x - v.drag.x) + Math.abs(p.y - v.drag.y) > 4) v.moved = true;
        if (v.s > 1.01) {
          v.tx = v.drag.tx + (p.x - v.drag.x);
          v.ty = v.drag.ty + (p.y - v.drag.y);
          apply();
        }
      }
    });

    function onPhoto(p) {
      var x = v.fit.x + v.tx;
      var y = v.fit.y + v.ty;
      return p.x >= x && p.x <= x + v.fit.w * v.s && p.y >= y && p.y <= y + v.fit.h * v.s;
    }

    function endPointer(e) {
      if (!v.pointers[e.pointerId]) return;
      var p = v.pointers[e.pointerId];
      delete v.pointers[e.pointerId];
      if (Object.keys(v.pointers).length < 2) v.pinch = null;
      if (v.drag && Object.keys(v.pointers).length === 0) {
        var dx = p.x - v.drag.startX;
        // Swipe for the next photo when not zoomed in.
        if (v.s <= 1.01 && Math.abs(dx) > 60 && v.photos.length > 1) {
          show(v.i + (dx < 0 ? 1 : -1));
        } else if (!v.moved && onPhoto(p)) {
          // Double-tap / double-click toggles zoom.
          var now = Date.now();
          if (now - v.lastTap < 320) {
            if (v.s > 1.01) reset();
            else zoomAt(p.x, p.y, 2.5);
            v.lastTap = 0;
          } else {
            v.lastTap = now;
          }
        }
        v.drag = null;
      }
    }
    stage.addEventListener('pointerup', endPointer);
    stage.addEventListener('pointercancel', endPointer);

    window.addEventListener('resize', function () {
      if (d.open) reset();
    });

    return v;
  }

  function openViewer(photos, i) {
    if (!viewer) viewer = buildViewer();
    viewer.open(photos, i);
  }

  function start() {
    document.querySelectorAll('[data-bf-pdp]').forEach(init);
    initVideos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
